import React, { useEffect } from 'react';
import './header.css';
import logo from '../icons/gymx-final-white.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleArrowRight } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';

function Header() {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);

  useEffect(() => {
    // Check if user is logged in
    const user = sessionStorage.getItem('user-info');
    if (user) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);


  return (
    <>
      <div className='sticky w-full top-0 z-10'>
        {/* Header Background */}
        <div className='bg-[#F7931E] w-full h-20 md:h-32 header'>
          {/* Header Content */}
          <div className='w-full h-16 md:h-28 bg-[#022A3A] header header-2 flex flex-col md:flex-row justify-between items-center px-4 md:px-10 p-[4px]'>
            {/* Logo */}
            <div className='flex items-center'>
              <img
                src={logo}
                alt='GymX Logo'
                className='w-32 md:w-48 h-auto' // Responsive logo size
              />
            </div>

            {/* Join Now Button */}
            <div className='flex items-center mt-2 md:mt-0 '>
              {/* Login Button */}
              {!isLoggedIn ? (
                <>
                  <button
                    className='font-bold text-[#022A3A] rounded-full bg-white px-5 py-1 text-sm md:text-base md:px-5 md:py-2 hover:bg-gray-200 transition-colors mr-3'
                    onClick={() => navigate('/login')}
                  >
                      Login
                  </button>
                
                  <button
                    className='font-bold text-[#022A3A] rounded-full bg-[#F7931E] px-3 py-1 text-sm md:text-base md:px-4 md:py-2 hover:bg-[#e68217] transition-colors'
                    onClick={() => navigate('/signup')}
                  >
                    Join Now <FontAwesomeIcon icon={faCircleArrowRight} className='ml-1' />
                  </button>
                </>
                ) : (
                <button
                  className='font-bold text-[#022A3A] rounded-full bg-white px-5 py-1 text-sm md:text-base md:px-5 md:py-2 hover:bg-gray-200 transition-colors mr-3'
                  onClick={() => navigate('/dashboard')}
                >
                  Back to Dashboard
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;